import { DotContent } from './DotContent';
import DotImage from './dotImage';
import DotVideo from './dotVideo';
import Blog from './blog';
import SuperParagraph from './SuperParagraph';
import CaseStudy from './caseStudy';
import YouTube from './youtube';
import { PieChart } from './pieChart.js';
import { Chart } from './chart.js';
import IFrameCodeBlock from './iFrameCode';
import Demo from './demo';
import { FAQGroup } from './faq';

const customRenderers = {
    IFrameCode: IFrameCodeBlock,
    Demo,
    faqGroup: FAQGroup,
    Blog,
    CaseStudy,
    dotContent: DotContent,
    dotVideo: DotVideo,
    dotImage: DotImage,
    SuperParagraph: SuperParagraph,
    youtube: YouTube,
    PieChart,
    Chart
};

export default customRenderers;
